import FacebookSdk from '@/modules/facebooksdk'
import Tracking from '@/modules/tracking'
import UserAgent from '@/modules/userAgent'

import Storage from '@/helpers/storage'

import Store from '@/store'
import I18n from "@/modules/i18n";

const SPECSDESKTOP = 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,location=no,status=no,rel="noopener,noreferrer,nofollow'
const SPECSMOBILE = 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,location=no,status=no,rel="noopener,noreferrer,nofollow'
const BASE_URL = 'https://cleanfox.io/save-the-planet/'

export default {

    to: function (Vue, media, dynamic) {

        return new Promise(resolve => {


            switch (media) {
                case 'facebook':
                    shareFacebook(Vue, dynamic, resolve)
                    break
                case 'twitter':
                    shareTwitter(Vue, dynamic, resolve)
                    break
                case 'whatsapp':
                    shareWhatsapp(Vue, dynamic, resolve)
                    break
                case 'email':
                    shareEmail(Vue, dynamic, resolve)
                    break
                case 'sms':
                    shareSMS(Vue, dynamic, resolve)
                    break
                case 'messenger':
                    shareMessenger(Vue, dynamic, resolve)
                    break
                case 'linkedin':
                    shareLinkedin(Vue, dynamic, resolve)
                    break
                case 'pinterest':
                    sharePinterest(Vue, dynamic, resolve)
                    break
                case 'instagram':
                    shareInstagram(resolve)
                    break
                case 'copyLink':
                    copyLink(Vue, dynamic, resolve)
                    break

            }
        })
    },

    downloadAndroidApp(blank) {

        const utms = `referrer%3D${Tracking.getTracking().referrer || ''}%26utm_campaign%3D${Tracking.getTracking().utm_campaign || ''}%26utm_medium%3D${Tracking.getTracking().utm_medium || ''}%26utm_source%3D${Tracking.getTracking().utm_source || ''}&partnerCode=${Storage.getItem('partnerCode')}`

        const url = `https://play.google.com/store/apps/details?id=io.cleanfox.android&referrer=${utms}`

        if (blank) {

            window.open(url, '_blank', 'noopener,noreferrer')

        } else {

            window.location.href = url

        }

    },

    downloadIosApp(blank) {

        const tracking = Tracking.getTrackingToQuery()

        const url = `https://cleanfox.app.link/SzXDwcINA3?${tracking}&partnerCode=${Storage.getItem('partnerCode')}`

        if (blank) {

            window.open(url, '_blank', 'noopener,noreferrer')

        } else {

            window.location.href = url

        }

    },
    
    rate(lang) {
        let trustLang = 'uk'
        switch (lang){
            case 'fr-fr':
                trustLang = 'fr'
                break
            case 'de-de':
                trustLang = 'de'
                break
            case 'da-dk':
                trustLang = 'dk'
                break
            case 'es-es':
                trustLang = 'es'
                break
            case 'it-it':
                trustLang = 'it'
                break
            case 'nl-be':
                trustLang = 'fr-be'
                break
            case 'nl-nl':
                trustLang = 'nl'
                break
            case 'pl-pl':
                trustLang = 'pl'
                break
            case 'pt-pt':
                trustLang = 'pt'
                break
            case 'sv-se':
                trustLang = 'se'
                break
            case 'ja-jp':
                trustLang = 'jp'
                break
        }
        
        window.open(`https://${trustLang}.trustpilot.com/review/www.cleanfox.io`, '_blank', 'noopener,noreferrer')
    
    }

}

async function shareFacebook(Vue, dynamic, resolve) {

    const options = {
        'mobile_iframe': true,
        href: 'https://www.cleanfox.io/share?&tstamp=' + new Date().getTime() + partnerCodeQuery(Vue, dynamic),
        quote: dynamic ? await dynamicText(Vue) : Vue.$t('sharing_generic_description')
    }
    FacebookSdk.shareFacebook(options)
    resolve()
}

async function shareTwitter(Vue, dynamic, resolve) {

    const body = encodeURIComponent(dynamic ? await dynamicText(Vue) : Vue.$t('sharing_twitter_description'))

    window.open(`https://twitter.com/intent/tweet?text=${body}`, '_blank', getSpecs()) //works

    resolve()

}

async function shareWhatsapp(Vue, dynamic, resolve) {

    const body = encodeURIComponent(dynamic ? await dynamicText(Vue) : Vue.$t('sharing_whatsapp_description'))

    if (UserAgent.is.mobile()) {

        window.open(`whatsapp://send?text=${body}`, '_blank', getSpecs())

    } else {

        window.open(`https://api.whatsapp.com/send?text=${body}`, '_blank', getSpecs())

    }

    resolve()
}

async function shareEmail(Vue, dynamic, resolve) {

    const title = encodeURIComponent(Vue.$t('sharing_mail_title'))
    const body = encodeURIComponent(dynamic ? await dynamicText(Vue) : Vue.$t('sharing_mail_description'))

    window.open(`mailto:?subject=${title}&body=${body}`, '_blank', getSpecs())

    resolve()
}

async function shareSMS(Vue, dynamic, resolve) {

    const body = encodeURIComponent(dynamic ? await dynamicText(Vue) : Vue.$t('sharing_generic_description'))

    if (UserAgent.is.ios()) {

        window.open(`sms:?body=${body}`, '_blank', 'noopener,noreferrer')

    } else {

        window.open(`sms:;body=${body}`, '_blank', 'noopener,noreferrer')

    }

    resolve()
}


async function shareMessenger(Vue, dynamic, resolve) {

    const body = encodeURIComponent(dynamic ? await dynamicText(Vue) : Vue.$t('sharing_facebook_description'))
    const link = `${BASE_URL}?` + partnerCodeQuery(Vue, dynamic)

    // https://developers.facebook.com/docs/sharing/messenger/web/
    if (UserAgent.is.mobile()) {
        window.open(`fb-messenger://share?link=${encodeURIComponent(link)}&app_id=${encodeURIComponent('184348308833280')}`, '_blank', 'noopener,noreferrer')
    } else {
        FacebookSdk.shareFacebook({
            method: 'send',
            link: BASE_URL
        })
    }
    resolve()
}

async function shareLinkedin(Vue, dynamic, resolve) {

    const url = encodeURIComponent(Vue.$t('sharing_linkedin_url'))
    const title = encodeURIComponent(Vue.$t('sharing_linkedin_title'))
    const body = encodeURIComponent(dynamic ? await dynamicText(Vue) : Vue.$t('sharing_linkedin_description'))

    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${body}&source=LinkedIn`, '_blank', getSpecs())

    resolve()
}

async function sharePinterest(Vue, dynamic, resolve) {

    const url = `${BASE_URL}?` + partnerCodeQuery(Vue, dynamic)// not required
    const imgToShow = 'https://www.cleanfox.io/static/dashboard/illu-fox-pile@2x.png' // todo: get image
    const body = encodeURIComponent(dynamic ? await dynamicText(Vue) : Vue.$t('sharing_generic_description'))

    window.open(`https://pinterest.com/pin/create/button/?url=${url}&media=${imgToShow}&description=${body}`, '_blank', getSpecs())

    resolve()
}

function shareInstagram(resolve) {

    window.open('https://www.instagram.com/p/BaJrL6MhK8p/?utm_source=ig_web_copy_link', '_blank', getSpecs()) //todo: get link
    resolve()

}

function copyLink(Vue, dynamic, resolve) {

    const text = `${BASE_URL}?utm_source=sharing&utm_medium=web` + partnerCodeQuery(Vue, dynamic)

    // createTextArea
    const textArea = document.createElement('textArea')
    textArea.value = text
    textArea.setAttribute('readonly', 'readonly')
    document.body.appendChild(textArea)

    // selectText
    if (UserAgent.is.ios()) {
        const range = document.createRange()
        range.selectNodeContents(textArea)
        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        textArea.setSelectionRange(0, 999999)
    } else {
        textArea.select()
    }

    // copyToClipboard
    document.execCommand('copy')
    document.body.removeChild(textArea)

    resolve()

}

function getSpecs() {

    if (UserAgent.is.mobile()) {
        return SPECSMOBILE
    } else {
        return SPECSDESKTOP
    }

}

function dynamicText(Vue) {

    return Store.dispatch('getStatsAsync')
        .then(stats => {

            const partnerCode = Vue.$store.getters.user.partnerCode
            const deleted = stats.user.deletedMails
            const str = Vue.$t('sharing_sharing_dynamic', 0, {nbMail: deleted, 'sharing_code': partnerCode})

            return str
        })
        .catch(() => {
            return Vue.$t('sharing_generic_description')
        })


}

function partnerCodeQuery(Vue, dynamic) {
    return dynamic ? '&partnerCode=' + Vue.$store.getters.user.partnerCode : ''
}
